export default "__VITE_ASSET__MtQWeALY__"